import { z } from 'zod';
export const ContentActionSchema = z.enum(['like', 'unlike', 'retweet', 'unretweet', 'bookmark', 'unbookmark']);
export type ContentAction = z.infer<typeof ContentActionSchema>;

export const ContentActionBodySchema = z.object({
  action: ContentActionSchema,
  tweetId: z.string().min(1),
});
export type ContentActionBody = z.infer<typeof ContentActionBodySchema>;

export const ContentInteractionBodySchema = z.object({
  tweetId: z.string().min(1),
});
export type ContentInteractionBody = z.infer<typeof ContentInteractionBodySchema>;

export const ContentActionResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});
export type ContentActionResponse = z.infer<typeof ContentActionResponseSchema>;
